/* eslint-disable import/no-unresolved */
import 'javascripts/showroom_renault/new_vehicles_index';
import 'stylesheets/showroom_renault/new_vehicles_index';
